import { memo } from "react";
import { GridActionsCellItem, type GridRowParams } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import { useResourceContext } from "ui/widgets/Resource";

const EditOpenBankingResource = ({ row }: GridRowParams) => {
    const { onOpen } = useResourceContext();
    const rowId = row.coreId ?? row.id;

    return (
        <GridActionsCellItem
            onClick={() => onOpen(row)}
            icon={<EditIcon />}
            label='Edit'
            data-test-id={`openBanking.table.row.${rowId}.actions.edit`}
        />
    );
};

export default memo(EditOpenBankingResource);
